module.exports = __webpack_public_path__ + "static/media/game-pointloss.4ff1a094.png";